class SearcherryStore {
  state = {
    isResultsFound: false
  }

  setIsResultFound (bool: boolean) {
    this.state.isResultsFound = bool
  }
}

const searcherryStore = new SearcherryStore()

export default searcherryStore
